import { Box, HStack } from '@chakra-ui/react'
import type { CalendarViewMode } from '../calendar-layout'

// Day / Week / Month, plus Today.
//
// Today sits outside the segmented group because it is an action, not a fourth
// mode: it moves the selection back to the current date and leaves whichever mode
// is active alone. Grouping it with the modes — as this panel did before — made it
// look selectable and left the viewer with no way to see which mode they were in.

interface ICalendarViewControlsProps {
  mode: CalendarViewMode
  onModeChange: (mode: CalendarViewMode) => void
  onToday: () => void
}

const MODES: { value: CalendarViewMode; label: string }[] = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' }
]

const ACTIVE_BG = '#003366'

const CalendarViewControls = ({ mode, onModeChange, onToday }: ICalendarViewControlsProps) => (
  <HStack spacing="8px">
    <HStack
      spacing={0}
      bg="rgba(255, 255, 255, 0.08)"
      borderRadius="20px"
      p="2px"
    >
      {MODES.map(item => {
        const isActive = mode === item.value
        return (
          <Box
            key={item.value}
            as="button"
            type="button"
            onClick={() => onModeChange(item.value)}
            w="78px"
            px="8px"
            py="4px"
            h="28px"
            borderRadius="20px"
            bg={isActive ? ACTIVE_BG : 'transparent'}
            color={isActive ? 'white' : 'rgba(255,255,255,0.65)'}
            fontSize="12px"
            fontWeight={600}
            border="none"
            cursor="pointer"
            _focus={{ boxShadow: 'none' }}
            _focusVisible={{ boxShadow: 'none' }}
          >
            {item.label}
          </Box>
        )
      })}
    </HStack>

    <Box
      as="button"
      type="button"
      onClick={onToday}
      px="12px"
      py="10px"
      h="32px"
      lineHeight="12px"
      borderRadius="24px"
      border="1px solid rgba(77, 179, 255, 0.30)"
      color="#4DB3FF"
      fontSize="12px"
      fontWeight={600}
      bg="transparent"
      cursor="pointer"
      _focus={{ boxShadow: 'none' }}
      _focusVisible={{ boxShadow: 'none' }}
    >
      Today
    </Box>
  </HStack>
)

export default CalendarViewControls
